import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import { USER_GROUPS, checkRequiredPermissions } from "../../../Utils/Common";

export default function ServiceItemModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  return checkRequiredPermissions([USER_GROUPS.SUPER_USER]) ? (
    <ListItem
      button
      onClick={() => {
        history.push("/cpanel/serviceitems");
        dispatch(showSidebar(false));
      }}
    >
      <ListItemIcon>
        <RoomServiceIcon />
      </ListItemIcon>
      <ListItemText primary={t("serviceItemsModule.header")} />
    </ListItem>
  ) : null;
}
